import type { MarketingVideoDescriptor } from './MarketingVideo.types'

// Cloudflare R2 public bucket, fronted by the BM CDN.
export const MARKETING_VIDEO_BASE_URL =
  'https://product-page-videos.statics.backmarket.com'

// Parity with YOUTUBE_VIDEO_TITLE (the YouTube embed's title).
export const MARKETING_VIDEO_TITLE = 'Used vs Verified'

// Default (and currently only) gallery video. The descriptor shape is
// deliberately generic so per-country / per-product maps or extra formats are
// a trivial extension later — the component stays asset-agnostic.
export const DEFAULT_MARKETING_VIDEO: MarketingVideoDescriptor = {
  // WebM first (smaller on Chrome/Firefox/Android), H.264 MP4 fallback
  // (Safari/iOS). The browser plays the first <source> it supports.
  files: ['used-vs-verified.webm', 'used-vs-verified.mp4'],
  // Bundled with the app (public/img), not the R2 bucket — the poster shows
  // immediately even before the video assets have loaded.
  posterFile: '/img/product/gallery/generic-poster.jpg',
  title: MARKETING_VIDEO_TITLE,
}
